import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Extract from './extract';

export default (
  <Route path="extrato">
    <IndexRoute component={(props) => <Extract {...props} />} />
  </Route>
);
